module.exports = __webpack_public_path__ + "img/2a8519901b39029f8c4ab97539202cf8.9d808e03.jpg";